import Link from 'next/link';
import { Button } from './button';
import { MapPinIcon } from '@/components/uielements/icon/map-pin';
import { ROUTES } from '@/constants/routes';

export function FindAlocation() {
  return (
    <Link href={ROUTES.STORES} passHref={true} legacyBehavior>
      <Button as="a">
        <MapPinIcon />
        Find a location
      </Button>
    </Link>
  );
}
